import Grid from "@mui/material/Unstable_Grid2";
import { Box, Typography } from "@mui/material";

//Carousel
import Carousel from "react-bootstrap/Carousel";

import logo1 from "./assete/silo/logo1.png";
//photo
import pic1 from "./assete/silo/pic1.png";
import pic2 from "./assete/silo/pic2.png";
import pic3 from "./assete/silo/pic3.png";
import pic4 from "./assete/silo/pic4.png";

const Silo = () => {
  return (
    <>
      <Grid container>
        <Grid xs={12}>
          <Box
            component="div"
            className="logo"
            sx={{
              display: "flex",

              justifyContent: "center",
              margin: "20px 0px",
            }}
          >
            <img src={logo1} alt="Logo" style={{ width: "10%" }}></img>
          </Box>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={6}>
          <Box component="div" className="text" sx={{ marginTop: "20px" }}>
            <Typography variant="h4" sx={{ fontFamily: "Homa" }}>
              سیستم کنترل ،مانیتورینگ و گزارشگیری
            </Typography>
            <ul
              style={{
                fontFamily: "Homa",
                marginTop: "15px",
                fontSize: "1.15rem",
              }}
            >
              <li>سیلوی 20 هزار تنی گندم کلاله استان گلستان</li>
              <li>سیلوی 20 هزار تنی گندم اسلام آباد غرب استان کرمانشاه </li>
              <li>سیلوی 30 هزار تنی گندم علی آباد استان گلستان</li>
              <li>سیلوی 30 هزار تنی گندم ارزوئیه استان کرمان</li>
              <li>سیلوی 40 هزار تنی گندم گنبد استان گلستان</li>
              <li>سیلوی 40 هزار تنی گندم تربت حیدریه استان خراسان جنوبی</li>
              <li>سیلوی 50 هزار تنی گندم دشت مغان استان اردبیل</li>
              <li>سیلوی 50 هزار تنی گندم سیرجان استان کرمان</li>
            </ul>
          </Box>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={6}>
          <Box component="div" sx={{ marginTop: "20px" }}>
            <Carousel style={{ width: "100%", float: "left" }}>
              <Carousel.Item>
                <img src={pic1} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic2} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic3} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic4} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
            </Carousel>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
export default Silo;
